import { reactQueryUtils } from "@lib/react-query";
import { accountApi, type TAccount } from "@/shared/services";

export const handleMobileOnboarding = async (account: TAccount) => {
  if (
    window.innerWidth > 1200 &&
    account.mobileOnboardingStartedAt &&
    !account.mobileOnboardingCompletedAt
  ) {
    const updatedAccount = await accountApi
      .setMobileOnboardingCompleted()
      .catch(() => null);
    if (updatedAccount)
      reactQueryUtils.setQueryData(["account"], updatedAccount);
  }
};
